import React from "react";
import Modal from "react-modal";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

// import SVG from 'react-inlinesvg';
// import classNames from 'classnames';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

export const SurveyModalThanks = ({
    isOpen,
    onClose,
}: IProps): React.ReactNode => {
    // TODO(i18n): Translate contentLabel attribute with t tagged template
    return (
        <Modal
            aria={{
                modal: true,
            }}
            style={{
                content: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxHeight: "95%",
                    maxWidth: "542px",
                    width: "96%",
                    overflow: "auto",
                    padding: "40px",
                },
            }}
            contentLabel="Survey"
            portalClassName="locator"
            className="locations store-locator-survey modal"
            isOpen={isOpen}
            onRequestClose={onClose}
            role="dialog"
        >
            <div className="modal-inner">
                <div
                    aria-label={t`Close`}
                    className="modal-close button--ghost"
                    onClick={onClose}
                >
                    <div className="pdp-modal__close-icon modal-close__icon"></div>
                </div>
                <div className="send__content survey__carousel">
                    <div className="survey-carousel-cell">
                        <h3>
                            {richT(t`Your directions<br />are on the way…`)}
                        </h3>
                        <p className="modal-intro">
                            {t`Thank you.`}
                            <br />
                            <br />
                            <button className="survey-taken">
                                {t`Continue to Results`}
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
